export default __webpack_public_path__ + "static/media/allgemein_38.6ef78221.jpg";